import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { Divider, Button, Table, Typography, notification, Popconfirm, Space } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import './index.less';

import _service from '@netuno/service-client';

const { Title } = Typography;

const langContext = 'reserved-area.construction';

export default ({ }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        _service({
            method: 'GET',
            url: '/construction/list',
            success: (response) => {
                setData(response.json);
                setLoading(false);
            },
            fail: (e) => {
                setLoading(false);
                notification["error"]({
                    message: 'Não foi possivel carregar os dados da tabela.',
                    description: e.response.json.error,
                });
            }
        });
    }, []);

    function onDeleteWork(uid) {
        setLoading(true);
        _service({
            method: 'DELETE',
            url: '/construction',
            data: { uid: uid },
            success: (response) => {
                if (response.json.result) {
                    const newData = data.filter(elem => elem.uid !== uid)
                    setData(newData);
                    setLoading(false);
                    notification["success"]({
                        message: 'Obra removida com sucesso',
                    });
                }
            },
            fail: (e) => {
                setLoading(false);
                notification["error"]({
                    message: 'Não foi possivel apagar a obra.',
                    description: e.response.json.error,
                });
            }
        });
    }

    const history = useHistory();
    const intl = useIntl();

    const columns = [
        {
            title: intl.formatMessage({ id: langContext + '.fields.name' }),
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: intl.formatMessage({ id: langContext + '.fields.address' }),
            dataIndex: 'address',
            key: 'address'
        },
        {
            title: intl.formatMessage({ id: langContext + '.fields.action' }),
            key: 'edit',
            width: '5%',
            render: data =>
                <Space>
                    <Button
                        title="Editar"
                        className="edit-row"
                        onClick={() => history.push(`/construction/edit/${data.uid}`)}>
                        <FormattedMessage id={`${langContext}.button.edit`} />
                    </Button>
                    <Popconfirm
                        title="Tem a certeza que deseja apagar a obra?"
                        onConfirm={() => onDeleteWork(data.uid)}
                        okText="Sim"
                        cancelText="Não"
                    >
                        <Button danger type='text' title='Apagar'><FormattedMessage id={`${langContext}.button.delete`} /></Button>
                    </Popconfirm>
                </Space>
        }
    ];

    return (
        <div className='construction'>
            <Title level={2}><FormattedMessage id={`${langContext}.title`} /></Title>
            <>
                <Button
                    className="construction__create-button"
                    type="primary"
                    onClick={() => history.push(`/construction/create`)}>
                    <FormattedMessage id={`${langContext}.button.create`} />
                </Button>
                <Divider />
            </>
            <Table
                loading={loading}
                dataSource={data}
                columns={columns}
            />
        </div>
    );
};
